import {Component, Input, OnInit} from '@angular/core';
import {PageService} from "../../../core/services/page.service";
import {DomSanitizer} from "@angular/platform-browser";
import {ActivatedRoute} from "@angular/router";
import {HybridToolsService} from '../../../core/services/hybrid-tools.service';

@Component({
    selector: 'app-preview',
    templateUrl: './preview.component.html',
    styleUrls: ['./preview.component.css']
})
export class PreviewComponent implements OnInit {

    @Input() public page: any = {};

    constructor(
      private pageService: PageService,
      private sanitizer: DomSanitizer,
      private activatedRoute: ActivatedRoute,
      public hybridToolsService: HybridToolsService
    ) {}

    ngOnInit() {
      // console.log("Init:", this.page);
    }

    reload() {
        this.page.fullUrl = '';
        setTimeout(() => {
            const isNationalTeamPage = this.activatedRoute.snapshot.queryParams['isNationalTeamPage'];
            const isTeam = this.activatedRoute.snapshot.queryParams['isTeam'];
            if (!!isNationalTeamPage) {
                this.page.fullUrl = this.pageService.nationalTeamPage.fullUrl;
            } else if (isTeam){
                this.page.fullUrl = this.pageService.teamPage.fullUrl;
            } else {
                this.page.fullUrl = this.pageService.userPage.fullUrl;
            }
        }, 100);
    }
}
